import { toastr } from 'react-redux-toastr';
import APP_ACTIONS from '../constants/app-actions';
import translations from '../../translations/app-translations.json';

// eslint-disable-next-line arrow-parens
const listenLogoutActionMiddleware = store => next => action => {
    if (action && action.type && action.type === APP_ACTIONS.LOGOUT) {
        const state = store.getState();
        if (state.user && state.user.id) {
            const locale = state.locale.currentLocale;
            toastr.success(`${translations[locale]['session-closed']}`);
        }
    }
    return next(action);
};

export default listenLogoutActionMiddleware;



/** WEBPACK FOOTER **
 ** ./src/middlewares/listen-logout-action-middleware.js
 **/